import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'


export type ImdbFragment = WpsTypes.atv.wps.ImdbFragmentModelProps | undefined
export type TitleIdToImdb = {
  [titleId: string]: ImdbFragment
}

export const reducer = createMergeReducer(t => t.imdb, {} as TitleIdToImdb)
